export const products = [
  { img: 'https://public.readdy.ai/ai/img_res/edited_bdc2f082d87d082df701c1b86a671c9b_23616679.jpg' },
  { img: 'https://readdy.ai/api/search-image?query=Wooden%20bowl%20of%20polished%20long%20grain%20white%20rice%20on%20soft%20cream%20linen%20background%2C%20bright%20natural%20daylight%2C%20clean%20minimal%20food%20product%20photography%2C%20gentle%20shadows&width=400&height=320&seq=lam-rice-02&orientation=landscape' },
  { img: 'https://storage.helloreaddy.io/project_files/35136070-61cb-45a9-b929-229bbdd5ade8/f3e2d214-6d2c-4048-90ff-8ef265a55057_compressed_2aOboR5gMhdRinKdtNgoV3hEi2sfkKPPcDn7XwdU.webp' },
  { img: 'https://storage.helloreaddy.io/project_files/35136070-61cb-45a9-b929-229bbdd5ade8/46f9f712-46ae-4df1-b6c6-b79a13fcf2c5_compressed_product-1792175479177-356594742.webp' },
];

export const aboutFeatures = [
  { icon: 'ri-leaf-line' },
  { icon: 'ri-global-line' },
  { icon: 'ri-hand-heart-line' },
];

export const sustainFeatures = [
  { icon: 'ri-user-heart-line' },
  { icon: 'ri-plant-line' },
  { icon: 'ri-team-line' },
];